import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { DOCTOR } from "@/data/content";

const waLink = `https://wa.me/${DOCTOR.whatsapp}?text=${encodeURIComponent(
  "Hello, I would like to know more about endoscopic spine surgery with Dr. Arun Reddy M."
)}`;

const FloatingActions = () => {
  return (
    <>
      {/* WhatsApp floating button */}
      <a
        href={waLink}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-float-btn"
        aria-label="Chat on WhatsApp"
        className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] shadow-[0_8px_30px_rgba(37,211,102,0.45)] flex items-center justify-center hover:scale-110 transition-transform"
      >
        <MessageCircle className="w-7 h-7 text-white" fill="white" />
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
      </a>

      {/* Mobile call button */}
      <a
        href={`tel:${DOCTOR.phoneRaw}`}
        data-testid="mobile-call-float-btn"
        aria-label="Call now"
        className="sm:hidden fixed bottom-6 left-6 z-40 w-14 h-14 rounded-full bg-brand shadow-[0_8px_30px_rgba(31,95,168,0.45)] flex items-center justify-center hover:scale-110 transition-transform"
      >
        <Phone className="w-6 h-6 text-white" />
      </a>
    </>
  );
};

export default FloatingActions;
